<template>
	<ProductDetailDialog v-model="open" :product-id="productId" />
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import ProductDetailDialog from '@/components/dialogs/ProductDetailDialog.vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';

const open = ref(false);
const productId = ref(null);
let amplify = null;

function evtModalProductAssortDetail(params) {
	const id = Number(params?.id);
	if (!id) return;
	productId.value = id;
	open.value = true;
}

onMounted(() => {
	amplify = iframeDataBridge.getIframeWindow()?.amplify || null;
	amplify?.subscribe('evtModalProductAssortDetail', evtModalProductAssortDetail);
});

onBeforeUnmount(() => {
	amplify?.unsubscribe('evtModalProductAssortDetail', evtModalProductAssortDetail);
	amplify = null;
});
</script>
